import React from 'react'
import Bg from '../../images/shapes/bg_pattern_4.svg'

const PageTitle = (props) => {
    // Determine the background image source
    const bgImage = props.bannerImage
        ? props.bannerImage
        : Bg;

    return (
        <section
            className="page_banner_section text-center"
            style={{
                position: 'relative',
                backgroundImage: `url(${bgImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                color: '#fff',
                padding: '60px 15px', // base padding for small screens
                minHeight: '40vh', // ensures a decent height on mobile
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column'
            }}
        >
            {/* Dark Overlay */}
            {props.bannerImage && (
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)', // 60% opacity for dark effect
                        zIndex: 1
                    }}
                />
            )}

            {/* Content on Top of Overlay */}
            <div style={{ position: 'relative', zIndex: 2, width: '100%' }}>
                <div className="container">
                    <div className="heading_focus_text text-white fs-5 fs-md-4 fs-lg-3 mb-3">
                        {/* {props.pageTop} */}
                        <span className="badge bg-secondary ms-2">{props.pagesub}</span>
                    </div>
                    <h1 className="page_title mb-0 text-white fs-2 fs-md-3 fs-lg-1">
                        {props.pageTitle}
                    </h1>
                </div>
            </div>
        </section>

    )
}

export default PageTitle;
